import { useEffect } from 'react';


const Iframe = () => {
    return (
        <iframe className='hidden' src="https://auth-tria.vercel.app"></iframe>
    )
}


export default Iframe
